import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom"; // If using React Router
import fflogowhite from "../Assets/fflogo-white.png";

const Footer = () => {
  const goToTop = () => {
    window.scrollTo(0, 0);
  };
  return (
    <footer className="footer">
      <Container fluid>
        <Row xs={12} className="logo-links-container">
          <Col xs={12} lg={3} className="footer-logo-container">
            <Link to="/">
              <img
                onClick={goToTop}
                className="footer-logo"
                src={fflogowhite}
                alt="Forward Focus Logo in white color"
              />
            </Link>
          </Col>
          <Col xs={12} lg={3} className="footer-links-container">
            <ul className="footer-links-ul">
              <li>
                <Link
                  onClick={goToTop}
                  to="/meetings"
                  className="footer-link-text"
                >
                  Meetings
                </Link>
              </li>
         <li>
                <Link
                  onClick={goToTop}
                  to="/issues"
                  className="footer-link-text"
                >
                Key Issues
                </Link>
              </li>  

            <li>
                <Link
                  onClick={goToTop}
                  to="/newsletters"
                  className="footer-link-text"
                >
                Newsletters
                </Link>
              </li> 
             {/*  <li>
                <Link
                  onClick={goToTop}
                  to="/maps"
                  className="footer-link-text"
                >
                  Maps
                </Link>
                
              </li> */}
          <li>
                <Link
                  onClick={goToTop}
                  to="/comments"
                  className="footer-link-text"
                >
                  Public Comments
                </Link>
              </li> 
         
              <li>
                <Link
                  onClick={goToTop}
                  to="/contact"
                  className="footer-link-text"
                >
               Contact Us
                </Link>
              </li>
         
            </ul>
          </Col>
          <Row style={{ display: "flex", justifyContent: "center" }}>
            <hr className="footer-divider" />
          </Row>
        </Row>

  {/*       <Row xs={12}>
          <Col className="social-media-icons-container">
            <i class="bi bi-facebook"></i>
            <i class="bi bi-twitter-x"></i>
            <i class="bi bi-instagram"></i>
            <i class="bi bi-envelope"></i>
          </Col>
        </Row> */}

        <Row xs={12}>
          <Col className="copyright-container">
            <p >
              <small >
                &copy; {new Date().getFullYear()} Forward Focus Alachua County
              </small>
            </p>
          </Col>
        </Row>
      </Container>

     
    </footer>
  );
};

export default Footer;
